var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 23,
    viewBox: "0 0 35 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 9.23974,
    transform: "matrix(0.726562 -0.687101 0.726562 0.687101 16.1087 10.728)",
    stroke: "#4F4F4F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.75,
    x2: 8.87977,
    y2: -0.75,
    transform: "matrix(-0.726562 -0.687101 0.726562 -0.687101 29.8186 22.168)",
    stroke: "#4F4F4F",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 22.9688,
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.852cdd33c5bed0dfab0c90504a79b35e.svg";
export { ForwardRef as ReactComponent };